import type { IClipboardProvider } from "@xterm/addon-clipboard";

// Replacement for the addon's BrowserClipboardProvider, which only accepts
// OSC 52 sequences whose selection param is exactly "c" — but tmux emits
// `\x1b]52;;<base64>` with an EMPTY selection param, so every copy-mode
// selection was silently dropped. This provider treats any selection
// (empty, c, p, s) as the system clipboard.
export class TmuxClipboardProvider implements IClipboardProvider {
  constructor(
    private readonly write: (text: string) => Promise<void> = (t) =>
      navigator.clipboard.writeText(t),
  ) {}

  // Never expose the user's clipboard to applications inside the terminal
  // (OSC 52 read queries): privacy, and Firefox would surface a paste
  // prompt on navigator.clipboard.readText().
  readText(): string {
    return "";
  }

  writeText(_selection: string, text: string): void | Promise<void> {
    if (!text) return;
    return this.write(text).catch(() => { /* lost user activation — ignore */ });
  }
}
